import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { BitwerxSubOfferingCardProps } from './types';
import { Button } from '@v2/components';
import { styles } from './styles';

const BitwerxSubOfferingCard: React.FC<BitwerxSubOfferingCardProps> = ({
  subOffering,
  onDelete,
}) => {
  const displayName = subOffering.displayName || subOffering.name;

  return (
    <div className={styles.container}>
      {onDelete && (
        <div className={styles.deleteButton}>
          <Button
            variant="ghost-danger"
            size="sm"
            onClick={() => onDelete(subOffering)}
            aria-label={`Delete ${displayName}`}
            icon={<FontAwesomeIcon icon={faTrash} />}
          />
        </div>
      )}
      <div className={styles.info}>
        <span className={styles.name}>{displayName}</span>
        <span className={styles.value}>{subOffering.name}</span>
      </div>
    </div>
  );
};

export default BitwerxSubOfferingCard;
